import header from "./beautiful-natural-scenery-balcony.jpg";
import section1 from "./female-planning-environment-projects.webp";
import section2 from "./tablet-and-DIN-277-terrasse.webp";
import section3 from "./resting-place-with-table-bench-chairs.jpg";
import section4 from "./plan-is-floor-man-is-making-repairs-apartment.jpg";
import section5 from "./terrace-on-balcony.jpg";
import section6 from "./close-up-hand-holding-plans.jpg";
import section7 from "./tablet-balkon-DIN-277.webp";
import section8 from "./analog-landscape-city-with-buildings.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
};
